export var AccountNameEnum;
(function (AccountNameEnum) {
    AccountNameEnum["CUSTOMER_DEFAULT_POOL"] = "CUSTOMER_DEFAULT_POOL";
    AccountNameEnum["BOG_BANK_WIRE_DEPOSIT_POOL"] = "BOG_BANK_WIRE_DEPOSIT_POOL";
    AccountNameEnum["BOG_BANK_WIRE_WITHDRAWAL_POOL"] = "BOG_BANK_WIRE_WITHDRAWAL_POOL";
    AccountNameEnum["BOG_CARD_DEPOSIT_POOL"] = "BOG_CARD_DEPOSIT_POOL";
    AccountNameEnum["BOG_CARD_WITHDRAWAL_POOL"] = "BOG_CARD_WITHDRAWAL_POOL";
    AccountNameEnum["FLITT_CARD_DEPOSIT_POOL"] = "FLITT_CARD_DEPOSIT_POOL";
    AccountNameEnum["FLITT_CARD_WITHDRAWAL_POOL"] = "FLITT_CARD_WITHDRAWAL_POOL";
    AccountNameEnum["TBC_BANK_WIRE_DEPOSIT_POOL"] = "TBC_BANK_WIRE_DEPOSIT_POOL";
    AccountNameEnum["TBC_BANK_WIRE_WITHDRAWAL_POOL"] = "TBC_BANK_WIRE_WITHDRAWAL_POOL";
    AccountNameEnum["TBC_CARD_DEPOSIT_POOL"] = "TBC_CARD_DEPOSIT_POOL";
    AccountNameEnum["TBC_CARD_WITHDRAWAL_POOL"] = "TBC_CARD_WITHDRAWAL_POOL";
    AccountNameEnum["FIREBLOCKS_DEPOSIT_POOL"] = "FIREBLOCKS_DEPOSIT_POOL";
    AccountNameEnum["FIREBLOCKS_WITHDRAWAL_POOL"] = "FIREBLOCKS_WITHDRAWAL_POOL";
    AccountNameEnum["WITHDRAWAL_FEE_POOL"] = "WITHDRAWAL_FEE_POOL";
    AccountNameEnum["EXCHANGE_FEE_POOL"] = "EXCHANGE_FEE_POOL";
    AccountNameEnum["LOAN_POOL"] = "LOAN_POOL";
    AccountNameEnum["COLLATERAL_POOL"] = "COLLATERAL_POOL";
    AccountNameEnum["LOAN_INTEREST_POOL"] = "LOAN_INTEREST_POOL";
    AccountNameEnum["CASH_POOL"] = "CASH_POOL";
    AccountNameEnum["STAKING_POOL"] = "STAKING_POOL";
    AccountNameEnum["SWAP_DEPOSIT_POOL"] = "SWAP_DEPOSIT_POOL";
    AccountNameEnum["EMPLOYEE_DEPOSIT_POOL"] = "EMPLOYEE_DEPOSIT_POOL";
})(AccountNameEnum || (AccountNameEnum = {}));
//# sourceMappingURL=account-name.enum.js.map